import React, { useState } from "react";
import { useForm } from "react-hook-form";
import Select from "react-select";
import { EditmarketCategoryAPI } from "../../../../Api/PanelAdminServices";
import { errorToast, succToast } from "../../../../Utils/Toast/Toast";
import Style from "./EditSecondLevelCategory.module.scss";
const EditSecondLevelCategory = ({
  info,
  setModalEditShow,
  category,
  getMarketCategory,
}) => {
  const [categoryId, setcategoryId] = useState(info.parent);
  const [disable, setDisable] = useState(false);
  ////////formhook part//////////////
  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm();
  ////////////post edited data///////////
  const onsubmit = (data) => {
    setDisable(true);
    let sendInfo = {
      id: info.key,
      parent: parseInt(categoryId),
      category_english: data.english,
      category_persian: data.persian,
      category_fee: data.fee,
      photo: "",
    };
    EditmarketCategoryAPI(sendInfo, (res) => {
      if (res.status === 1) {
        succToast("با موفقیت ویرایش شد");
        setDisable(false);
        setModalEditShow(false);
      } else {
        errorToast("مشکلی پیش آمده");
        setDisable(false);
      }
    });
    getMarketCategory();
  };
  ////////////get category part///////////////

  const getCategory1OnChange = (e) => {
    setcategoryId(e.value);
  };
  let categoryOption =
    category &&
    category.map((item) => {
      return { value: item.id, label: item.category, parent: item.parent };
    });
  let categoryFirst = [];
  categoryOption.forEach((val) => {
    if (val.parent === "2") {
      categoryFirst.push(val);
    }
  });

  return (
    <form onSubmit={handleSubmit(onsubmit)} className={Style.levelOne}>
      <Select
        onChange={(e) => getCategory1OnChange(e)}
        options={categoryFirst}
        value={categoryFirst.filter((option) => option.value === categoryId)}
        className={Style.selectOptionsearch}
        placeholder={"دسته بندی اول"}
      />
      <input
        {...register("persian", { required: true })}
        className={errors.persian ? Style.inputError : Style.inputPart}
        placeholder="نام دسته بندی به فارسی"
        defaultValue={info.namePersian}
      />
      <input
        {...register("english", { required: true })}
        className={errors.english ? Style.inputError : Style.inputPart}
        placeholder="نام دسته بندی به انگلیسی"
        defaultValue={info.nameEnglish}
      />
      <input
        {...register("fee", { required: true })}
        className={errors.fee ? Style.inputError : Style.inputPart}
        placeholder="کارمزد مربوط به این دسته بندی"
        defaultValue={info.categoryFee}
      />
      <div className={Style.btnHolder}>
        <button type="submit" className={Style.addBtn} disabled={disable}>
          ویرایش
        </button>
      </div>
    </form>
  );
};

export default EditSecondLevelCategory;
